export const IMAGE_INDICATOR = "httpImage/";
export const DERIVATIVE_PREFIX = "httpImage/image";
export const DERIVATIVE_SUFFIX = "_gen/derivatives/";
export const DERIVATIVE_SIZE_PLACEHOLDER = "SIZE";

// Derivative values from Polopoly
export const DEFAULT_DERIVATIVE_WIDTHS = [300, 460, 620, 780, 1180];
